(function () {
  'use strict';

  function init() {
    var blocks = document.querySelectorAll('[data-mc-story]');
    if (!blocks.length) return;

    if (!('IntersectionObserver' in window)) {
      blocks.forEach(function (b) { b.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

    blocks.forEach(function (b) { observer.observe(b); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();